/* eslint-disable */
import { produce } from "immer";
import {
  BACK_BUTTON_RETIREMENT_APPLICATION_STEPS,
  BEGIN_RETIREMENT_APPLICATION_CLICK_START,
  NEXT_BUTTON_RETIREMENT_APPLICATION_STEPS,
  RETIREMENT_APPLICATION_FETCH_FAILURE,
  RETIREMENT_APPLICATION_FETCH_START,
  RETIREMENT_APPLICATION_FETCH_SUCCESS,
  RETIREMENT_APPLICATION_PATCH_FAILURE,
  RETIREMENT_APPLICATION_PATCH_START,
  RETIREMENT_APPLICATION_PATCH_SUCCESS,
  RETIREMENT_CHOOSE_APPLICATION_SUB_STEPS,
  RETIREMENT_CHOOSE_START_AGAIN_POT_SELECTION,
  RETIREMENT_CONFIRM_CHOICE_SUB_STEPS,
  RETIREMENT_DIRECT_STEP_CHANGE,
  SET_RETIREMENT_APPLICATION_DETAILS,
} from "../actions/types";
import { backButtonHandler, editButtonHandler, stepsHandler } from "../helpers/stepsHandles";
import {
  RA_STEPS_IDENTIFIERS,
  addOnStep,
  initialRaSteps,
  taxFreeAddonStep,
  moneyinchunksAddonStep,
  contributionStep,
  guaranteedAnnuityAddonStep,
  regularIncomeAddonStep,
  mixMatchAddonStep,
  regularIncomeAddonStepForActiveUsers,
  mixMatchAddonStepForActiveUsers,
  taxFreeAddonStepForActiveUser,
} from "../constants";

const retirementApplication = (
  state = {
    fetching: false,
    data: {},
    error: null,
    patchFetching: false,
    patchData: [],
    patchError: null,
    steps: initialRaSteps,
    applicationSteps: {
      isShowBeforeStart: true,
      isRetirementDate: false,
      isPensionWise: false,
      isLumpSumAllowances: false,
      isPotSelection: false,
      isRetirementChoice: false,
      isConfirmChoice: false,
      isIllustration: false,
      isBankMandate: false,
      isBankMandateConfirm: false,
      isInvestRest: false,
      isIdv: false,
      isConfirmDeclaration: false,
      isDeclaration: false,
      isTakeMoneyInOneChunk: false,
      isContribution: false,
      isAnnuity: false,
      isRegularHowMuchCash: false,
      isTakingRegularIncome: false,
      isMixMatchHowMuchCash: false,
      isMixandMatch: false,
    },
    chooseRetirementSteps: {
      isTakeMoneyInOneGo: false,
      isTakeTaxFreeCashInvestRest: false,
      isTakeMoneyInOneChunk: false,
      isAnnuityHowMuchCash: false,
      isRegularHowMuchCash: false,
      isMixMatchHowMuchCash: false,
    },
    currentStep: "",
    confirm:{},
    guide: {},
    pension: {},
    choiceCategory: {},
    choose: {},
    potSelection: {},
    contribution: {},
    taxfreecash: {},
    moneyinonego: {},
    investrest: {},
    moneyinchunk: {},
    regularchoice: {},
    regularincome: {},
    annuityprovider: {},
    mixmatchchoice: {},
    mixmatch: {},
    illustration: {},
    bankDetails: {},
    idv: {},
    declaration: {},
    annuitychoice: {},
    throughGetAPI: false,
    taxFreeCashAsLumpSumChosen: false,
    throughEditButton: false,
  },
  action,
) => {
  switch (action.type) {
    case RETIREMENT_APPLICATION_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });

    case RETIREMENT_APPLICATION_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;

        //LOGIC CHANGE BASED ON THE API RESPONSE

        if (
          action?.data?.confirm &&
          Object.keys(action?.data?.confirm).length > 0
        ) {
          draft.currentStep = RA_STEPS_IDENTIFIERS.RA_APPLICATION_WAKE_UP_INFO;
        }
        if (
          action?.data?.guide &&
          Object.keys(action?.data?.guide).length > 0 &&
          action?.data?.guide?.submitted
        ) {
          draft.currentStep = RA_STEPS_IDENTIFIERS.RA_PENSION_WISE;
        }
        if (
          action?.data?.pension &&
          Object.keys(action?.data?.pension).length > 0 &&
          action?.data?.pension?.lumpsumAllowancesSubmitted
        ) {
          draft.currentStep = RA_STEPS_IDENTIFIERS.RA_LUMP_SUM_ALLOWANCES;
        }

        if (
          action?.data?.choose &&
          Object.keys(action?.data?.choose).length > 0
        ) {
          draft.currentStep = RA_STEPS_IDENTIFIERS.RA_POT_SELECTION;
        }
        const editPhase =
          (localStorage.getItem("chooseRetirement") === "ChooseYourRetirement");
        //TAKE ALL IN ONE GO
        if (
          action?.data?.choiceCategory &&
          Object.keys(action?.data?.choiceCategory).length > 0 &&
          action?.data?.choiceCategory?.choiceSelected ===
            "TAKE_ALL_IN_ONE_GO" &&
          action?.data?.choiceCategory?.choiceSubmitted === true &&
          !editPhase
        ) {
          draft.steps.map((step, i) => {
            if (step.sequence === 3 && step.subSteps.length < 3) {
              step.subSteps = [...step.subSteps, ...addOnStep];
            }
          });
          draft.throughGetAPI = true;
          draft.chooseRetirementSteps.isTakeMoneyInOneGo = true;
          draft.moneyinonego = action?.data?.choiceCategory?.takeAllInOneGo;
          draft.currentStep = RA_STEPS_IDENTIFIERS.RA_TAKE_ALL_IN_ONE_GO;
        }

        //TAKE TAX_FREE_CASH_INVEST_THE_REST
        if (
          action?.data?.choiceCategory &&
          Object.keys(action?.data?.choiceCategory).length > 0 &&
          (action?.data?.choiceCategory?.choiceSelected ===
            "TAKE_TAX_FREE_CASH_LUMSUM_INVEST_THE_REST" ||
            action?.data?.choiceCategory?.choiceSelected ===
              "TAKE_TAX_FREE_CASH_REGULAR_INCOME_INVEST_THE_REST") &&
          action?.data?.choiceCategory?.choiceSubmitted === true &&
          !editPhase
        ) {
          draft.steps.map((step, i) => {
            if (step.sequence === 3 && step.subSteps.length < 3) {
              step.subSteps = [
                ...step.subSteps,
                ...taxFreeAddonStepForActiveUser,
              ];
            }
          });
          draft.throughGetAPI = true;
          draft.taxfreecash = action?.data?.choiceCategory?.taxFreeCash;
          draft.chooseRetirementSteps.isTakeTaxFreeCashInvestRest = true;
          draft.currentStep = RA_STEPS_IDENTIFIERS.RA_INVEST_THE_REST;
        }

        //TAKE MONEY IN CHUNKS
        if (
          action?.data?.choiceCategory &&
          Object.keys(action?.data?.choiceCategory).length > 0 &&
          action?.data?.choiceCategory?.choiceSelected ===
            "TAKE_MONEY_IN_CHUNKS" &&
          action?.data?.choiceCategory?.choiceSubmitted === true &&
          !editPhase
        ) {
          draft.steps.map((step, i) => {
            if (step.sequence === 3 && step.subSteps.length < 3) {
              step.subSteps = [...step.subSteps, ...moneyinchunksAddonStep];
            }
          });
          draft.throughGetAPI = true;
          draft.moneyinchunk = action?.data?.choiceCategory?.takeMoneyInChunks;
          draft.chooseRetirementSteps.isTakeMoneyInOneChunk = true;
          draft.currentStep = RA_STEPS_IDENTIFIERS.RA_TAKE_MONEY_IN_CHUNKS;
        }

        //TAKE GUARANTEED INCOME ANNUITY
        if (
          action?.data?.choiceCategory &&
          Object.keys(action?.data?.choiceCategory).length > 0 &&
          action?.data?.choiceCategory?.choiceSelected ===
            "TAKE_GUARANTEED_INCOME_ANNUITY" &&
          action?.data?.choiceCategory?.choiceSubmitted === true &&
          !editPhase
        ) {
          draft.steps.map((step, i) => {
            if (step.sequence === 3 && step.subSteps.length < 3) {
              step.subSteps = [...step.subSteps, ...guaranteedAnnuityAddonStep];
            }
          });
          draft.annuitychoice =
            action?.data?.choiceCategory?.takeGuaranteedIncomeAnnuity;
          draft.throughGetAPI = true;
          draft.chooseRetirementSteps.isAnnuityHowMuchCash = true;
          draft.currentStep = RA_STEPS_IDENTIFIERS.RA_ANNUITY_PROVIDER;
        }

        //TAKE REGULAR INCOME FROM TPT DRAWDOWN
        if (
          action?.data?.choiceCategory &&
          Object.keys(action?.data?.choiceCategory).length > 0 &&
          action?.data?.choiceCategory?.choiceSelected ===
            "TAKE_TAX_FREE_CASH_REGULAR_INCOME" &&
          action?.data?.choiceCategory?.choiceSubmitted === true &&
          !editPhase
        ) {
          draft.steps.map((step, i) => {
            if (step.sequence === 3 && step.subSteps.length < 3) {
              step.subSteps = [...step.subSteps, ...regularIncomeAddonStep];
            }
          });
          draft.throughGetAPI = true;
          draft.regularchoice = action?.data?.choiceCategory?.regularIncome;
          draft.chooseRetirementSteps.isRegularHowMuchCash = true;
          draft.currentStep = RA_STEPS_IDENTIFIERS.RA_RI_INVEST_THE_REST;
        }

        //TAKE MIX AND MATCH
        if (
          action?.data?.choiceCategory &&
          Object.keys(action?.data?.choiceCategory).length > 0 &&
          action?.data?.choiceCategory?.choiceSelected ===
            "TAKE_TAX_FREE_CASH_MIX_AND_MATCH" &&
          action?.data?.choiceCategory?.choiceSubmitted === true &&
          !editPhase
        ) {
          draft.steps.map((step, i) => {
            if (step.sequence === 3 && step.subSteps.length < 3) {
              step.subSteps = [...step.subSteps, ...mixMatchAddonStep];
            }
          });
          draft.throughGetAPI = true;
          draft.mixmatchchoice = action?.data?.choiceCategory?.mixNmatch;
          draft.chooseRetirementSteps.isMixMatchHowMuchCash = true;
          draft.currentStep = RA_STEPS_IDENTIFIERS.RA_BEND_STRATEGIES;
        }
        if (
          action?.data?.bankDetails &&
          Object.keys(action?.data?.bankDetails).length > 0
        ) {
          draft.currentStep = RA_STEPS_IDENTIFIERS.BANK_MANDATE_CONFIRM;
        }
        if (
          action?.data?.declaration &&
          Object.keys(action?.data?.declaration).length > 0
        ) {
          draft.currentStep = RA_STEPS_IDENTIFIERS.RA_CONFIRM_DETAILS;
        }
        if (action?.data?.confirm) {
          draft.confirm = action?.data?.confirm;
        }
        if (action?.data?.guide) {
          draft.guide = action?.data?.guide;
        }
        if (action?.data?.pension) {
          draft.pension = action?.data?.pension;
        }
        if (action?.data?.choose) {
          draft.choose = action?.data?.choose;
        }

        if (action?.data?.bankDetails) {
          draft.bankDetails = action?.data?.bankDetails;
        }
        if (action?.data?.idv && Object.keys(action?.data?.idv).length > 0) {
          draft.currentStep = RA_STEPS_IDENTIFIERS.RA_IDENTITY_AND_VERIFICATION;
        }

        if (action?.data?.declaration) {
          draft.declaration = action?.data?.declaration;
        }
        if (
          action?.data?.applicationSubmitted &&
          draft.currentStep !== RA_STEPS_IDENTIFIERS.RA_APPLICATION_WAKE_UP_INFO
        ) {
          draft.currentStep = RA_STEPS_IDENTIFIERS.RA_APPLICATION_WAKE_UP_INFO;
          for (const key in draft.applicationSteps) {
            if (
              draft.applicationSteps.hasOwnProperty.call(
                draft.applicationSteps,
                key
              )
            ) {
              draft.applicationSteps[key] = false;
            }
          }
          for (const key in draft.chooseRetirementSteps) {
            draft.chooseRetirementSteps[key] = false;
          }

          draft.throughGetAPI = false;
          draft.taxFreeCashAsLumpSumChosen = false;
          draft.throughEditButton = false;

          draft.confirm = {};
          draft.guide = {};
          draft.pension = {};
          draft.choiceCategory = {};
          draft.choose = {};
          draft.potSelection = {};
          draft.contribution = {};
          draft.taxfreecash = {};
          draft.moneyinonego = {};
          draft.investrest = {};
          draft.moneyinchunk = {};
          draft.regularchoice = {};
          draft.regularincome = {};
          draft.annuityprovider = {};
          draft.mixmatchchoice = {};
          draft.mixmatch = {};
          draft.illustration = {};
          draft.bankDetails = {};
          draft.idv = {};
          draft.declaration = {};
          draft.annuitychoice = {};
        }
        draft.fetching = false;
        stepsHandler(draft, draft.currentStep, state);
      });

    case RETIREMENT_APPLICATION_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });

    case RETIREMENT_APPLICATION_PATCH_START:
      return produce(state, (draft) => {
        draft.patchFetching = true;
      });

    case RETIREMENT_APPLICATION_PATCH_SUCCESS:
      return produce(state, (draft) => {
        draft.patchFetching = true;
        draft.patchData = action.data;
        draft.patchFetching = false;
        draft.currentStep = action?.data?.currentStep;
        if (
          action.editingPage === "GuidanceAndAdvice" ||
          action.editingPage === "PensionWiseGuidance" ||
          action.editingPage === "BankMandate" ||
          action.editingPage === "ChooseYourRetirement"
        ) {
          if (action.editingPage === "ChooseYourRetirement") {
            localStorage.setItem("chooseRetirement", "ChooseYourRetirement");
            localStorage.setItem("isEditStillOn", true);
          }
          draft.throughEditButton = true;
        }
        stepsHandler(draft, action?.data?.currentStep, state);
      });

    case RETIREMENT_APPLICATION_PATCH_FAILURE:
      return produce(state, (draft) => {
        draft.patchFetching = false;
        draft.patchError = action.error;
      });

    case SET_RETIREMENT_APPLICATION_DETAILS:
      return produce(state, (draft) => {
        switch (action?.data?.currentStep) {
          case RA_STEPS_IDENTIFIERS.RA_APPLICATION_DATE:
            draft.guide = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.RA_PENSION_WISE:
            draft.guide = action.data?.details;
            break;

          case RA_STEPS_IDENTIFIERS.RA_LUMP_SUM_ALLOWANCES:
            draft.pension = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.RA_CONTRIBUTION:
            draft.contribution = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.RA_CONFIRM_CHOICE:
            draft.choiceCategory = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.RA_TAX_FREE_CASH:
            draft.taxfreecash = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.RA_INVEST_THE_REST:
            draft.investrest = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.RA_TAKE_MONEY_IN_CHUNKS:
            draft.moneyinchunk = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.RA_POT_SELECTION:
            draft.potSelection = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.RA_ANNUITY_CHOICE:
            draft.annuitychoice = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.RA_ANNUITY_PROVIDER:
            draft.annuityprovider = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.RA_MM_CASH_LUMPSUM:
            draft.mixmatchchoice = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.RA_BEND_STRATEGIES:
            draft.mixmatch = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.RA_RI_CASH_LUMPSUM:
            draft.regularchoice = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.RA_RI_INVEST_THE_REST:
            draft.regularincome = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.RA_ILLUSTRATION:
            draft.illustration = action.data?.details;
            break;
          case RA_STEPS_IDENTIFIERS.BANK_MANDATE:
            draft.bankDetails = action.data?.details;
            break;

          default:
            break;
        }
      });


    case BEGIN_RETIREMENT_APPLICATION_CLICK_START:
      return produce(state, (draft) => {
        draft?.steps.map((step) => {
          if (step.identifier === action?.data) {
            step.isSubStepsOpen = true;
          } else {
            step.isSubStepsOpen = false;
          }
        });
        switch (action?.data) {
          case RA_STEPS_IDENTIFIERS.RETIREMENT_DATE_AND_GUIDANCE:
            draft.applicationSteps.isPensionWise = true;
            break;
          case RA_STEPS_IDENTIFIERS.OTHER_PENSIONS:
            draft.applicationSteps.isLumpSumAllowances = true;
            break;
          case RA_STEPS_IDENTIFIERS.CHOOSING_YOUR_RETIREMENT:
            draft.applicationSteps.isPotSelection = true;
            break;
          case RA_STEPS_IDENTIFIERS.BANK_MANDATE:
            draft.applicationSteps.isBankMandate = true;
            break;
          case RA_STEPS_IDENTIFIERS.RA_IDENTITY_AND_VERIFICATION:
            draft.applicationSteps.isIdv = true;
            break;
          case RA_STEPS_IDENTIFIERS.DECLARATION:
            draft.applicationSteps.isConfirmDeclaration = true;
            break;
          case RA_STEPS_IDENTIFIERS.RA_CONFIRM_DETAILS:
            draft.applicationSteps.isDeclaration = true;
            break;
          case RA_STEPS_IDENTIFIERS.RA_APPLICATION_SUCCESS:
            draft.applicationSteps.isShowBeforeStart = false;
            break;

          default:
            break;
        }
      });

    case BACK_BUTTON_RETIREMENT_APPLICATION_STEPS:
      return produce(state, (draft) => {
        if (action.data?.isHomeScreen) {
          draft.steps.map((step) => {
            step.isSubStepsOpen = false;
          });
          draft.applicationSteps = {
            ...state.applicationSteps,
            ...{
              isRetirementDate: false,
              isPensionWise: false,
              isLumpSumAllowances: false,
              isPotSelection: false,
              isRetirementChoice: false,
              isConfirmChoice: false,
              isIllustration: false,
              isBankMandate: false,
              isBankMandateConfirm: false,
              isInvestRest: false,
              isAnnuityHowMuchCash: false,
              isAnnuity: false,
              isRegularHowMuchCash: false,
              isTakingRegularIncome: false,
              isMixMatchHowMuchCash: false,
              isMixandMatch: false,
              isIdv: false,
              isConfirmDeclaration: false,
              isDeclaration: false,
            },
          };
        } else if (action.data?.backButtonClicked) {
          for (const key in draft.applicationSteps) {
            if (
              draft.applicationSteps.hasOwnProperty.call(
                draft.applicationSteps,
                key
              )
            ) {
              draft.applicationSteps[key] = false;
            }
          }
          backButtonHandler(draft.steps, action?.data?.mainStepNo);
          draft.applicationSteps = draft.applicationSteps = {
            ...draft.applicationSteps,
            ...action.data?.disableSection,
          };
          if (action?.data?.mainStepNo === 33) {
            draft.steps[2].subSteps = draft.steps[2].subSteps?.splice(0, 2);
          }
        } else {
          if (action?.data?.mainStepNo === 2) {
            draft.steps[action?.data?.mainStepNo].subSteps = draft.steps[
              action?.data?.mainStepNo
            ].subSteps?.splice(0, 2);
          }
          editButtonHandler(draft.steps, action?.data?.mainStepNo);
          draft.applicationSteps = draft.applicationSteps = {
            ...state.applicationSteps,
            ...action.data?.disableSection,
          };
        }
      });

    case NEXT_BUTTON_RETIREMENT_APPLICATION_STEPS:
      return produce(state, (draft) => {
        if (typeof action?.data === "object") {
          draft.currentStep = action?.data?.currentStep;
          draft.bankDetails = action?.data?.dataObject;
        } else {
          draft.currentStep = action?.data;
        }
        stepsHandler(draft, draft.currentStep, state);
      });

    case RETIREMENT_CHOOSE_APPLICATION_SUB_STEPS:
      return produce(state, (draft) => {
        for (const key in draft.chooseRetirementSteps) {
          if (
            draft.chooseRetirementSteps.hasOwnProperty.call(
              draft.chooseRetirementSteps,
              key
            )
          ) {
            draft.chooseRetirementSteps[key] = false;
          }
        }
        for (const key in draft.applicationSteps) {
          if (
            draft.applicationSteps.hasOwnProperty.call(
              draft.applicationSteps,
              key
            )
          ) {
            draft.applicationSteps[key] = false;
          }
        }

        draft.chooseRetirementSteps = {
          ...Object.keys(state.chooseRetirementSteps).reduce((acc, key) => {
            acc[key] = false;
            return acc;
          }, {}),
          ...action.data,
        };
        if (draft?.chooseRetirementSteps?.isTakeMoneyInOneGo) {
          draft.currentStep = "RA_RETIREMENT_CHOICE";
          draft.steps.map((step, i) => {
            if (step.sequence === 3 && step.subSteps.length < 3) {
              if (draft?.chooseRetirementSteps?.activeUser) {
                let contributionStepAddition = [
                  {
                    name: "Your contributions",
                    identifier: "RA_CONTRIBUTION",
                    isSubBegin: false,
                    isSubComplete: false,
                    isSubUpComing: true,
                    sequence: 34,
                  },
                ];
                step.subSteps = [
                  ...step.subSteps,
                  ...JSON.parse(JSON.stringify(addOnStep)),
                  ...JSON.parse(JSON.stringify(contributionStepAddition)),
                ];
              } else {
                step.subSteps = [
                  ...step.subSteps,
                  ...JSON.parse(JSON.stringify(addOnStep)),
                ];
              }
            }
          });
        }

        if (draft?.chooseRetirementSteps?.isTakeTaxFreeCashInvestRest) {
          draft.currentStep = "RA_RETIREMENT_CHOICE";
          draft.steps.map((step, i) => {
            if (step.sequence === 3 && step.subSteps.length < 3) {
              step.subSteps = [...step.subSteps, ...JSON.parse(JSON.stringify(taxFreeAddonStep))];
            }
          });
        }
        if (draft?.chooseRetirementSteps?.isInvestRest) {
          draft.currentStep = "RA_RETIREMENT_CHOICE";
          draft.chooseRetirementSteps.isTakeTaxFreeCashInvestRest = true;
          draft.steps.map((step, i) => {
            if (step.sequence === 3 && step.subSteps.length < 7) {
              if (
                draft?.chooseRetirementSteps?.activeUser &&
                draft?.chooseRetirementSteps?.asLumpSum
              ) {
                draft.taxFreeCashAsLumpSumChosen = true;
                step.subSteps = step.subSteps?.splice(0, 2);
                if (step.subSteps.length === 2) {
                  step.subSteps = [
                    ...step.subSteps,
                    ...JSON.parse(
                      JSON.stringify(taxFreeAddonStepForActiveUser)
                    ),
                  ];
                }
              } else if (draft?.chooseRetirementSteps?.asLumpSum) {
                draft.taxFreeCashAsLumpSumChosen = true;
                step.subSteps = step.subSteps?.splice(0, 2);
                
                const trimmedAddonStepToAvoidMutation = taxFreeAddonStepForActiveUser.slice(0, -1);

                if (step.subSteps.length === 2) {
                  step.subSteps = [
                    ...step.subSteps,
                    ...JSON.parse(
                      JSON.stringify(trimmedAddonStepToAvoidMutation)
                    ),
                  ];
                }
              } else {
                draft.taxFreeCashAsLumpSumChosen = false;
              }
            }
          });
        }
        if (draft?.chooseRetirementSteps?.isTakeMoneyInOneChunk) {
          draft.currentStep = "RA_RETIREMENT_CHOICE";
          draft.steps.map((step, i) => {
            if (step.sequence === 3 && step.subSteps.length < 3) {
              if (draft?.chooseRetirementSteps?.activeUser) {
                let contributionStepAddition = [
                  {
                    name: "Your contributions",
                    identifier: "RA_CONTRIBUTION",
                    isSubBegin: false,
                    isSubComplete: false,
                    isSubUpComing: true,
                    sequence: 35,
                  },
                ];
                step.subSteps = [
                  ...step.subSteps,
                  ...JSON.parse(JSON.stringify(moneyinchunksAddonStep)),
                  ...JSON.parse(JSON.stringify(contributionStepAddition)),
                ];
              } else {
                step.subSteps = [
                  ...step.subSteps,
                  ...JSON.parse(JSON.stringify(moneyinchunksAddonStep)),
                ];
              }
            }
          });
        }
        if (draft?.chooseRetirementSteps?.isAnnuityHowMuchCash) {
          draft.currentStep = "RA_RETIREMENT_CHOICE";
          draft.steps.map((step, i) => {
            if (step.sequence === 3 && step.subSteps.length < 3) {
              if (draft?.chooseRetirementSteps?.activeUser) {
                let contributionStepAddition = [
                  {
                    name: "Your contributions",
                    identifier: "RA_CONTRIBUTION",
                    isSubBegin: false,
                    isSubComplete: false,
                    isSubUpComing: true,
                    sequence: 36,
                  },
                ];
                step.subSteps = [
                  ...step.subSteps,
                  ...JSON.parse(JSON.stringify(guaranteedAnnuityAddonStep)),
                  ...JSON.parse(JSON.stringify(contributionStepAddition)),
                ];
              } else {
                step.subSteps = [
                  ...step.subSteps,
                  ...JSON.parse(JSON.stringify(guaranteedAnnuityAddonStep)),
                ];
              }
            }
          });
        }
        if (draft?.chooseRetirementSteps?.isRegularHowMuchCash) {
          draft.currentStep = "RA_RETIREMENT_CHOICE";
          draft.steps.map((step, i) => {
            if (step.sequence === 3 && step.subSteps.length < 3) {
              if (draft?.chooseRetirementSteps?.activeUser) {
                step.subSteps = [
                  ...step.subSteps,
                  ...JSON.parse(JSON.stringify(regularIncomeAddonStepForActiveUsers)),
                ];
              } else {
                step.subSteps = [...step.subSteps, ...JSON.parse(JSON.stringify(regularIncomeAddonStep))];
              }
            }
          });
        }
        if (draft?.chooseRetirementSteps?.isMixMatchHowMuchCash) {
          draft.currentStep = "RA_RETIREMENT_CHOICE";
          draft.steps.map((step, i) => {
            if (step.sequence === 3 && step.subSteps.length < 3) {
              if (draft?.chooseRetirementSteps?.activeUser) {
                step.subSteps = [
                  ...step.subSteps,
                  ...JSON.parse(JSON.stringify(mixMatchAddonStepForActiveUsers)),
                ];
              } else {
                step.subSteps = [...step.subSteps, ...JSON.parse(JSON.stringify(mixMatchAddonStep))];
              }
            }
          });
        }

        draft.steps[2].subSteps.forEach((item, index) => {
          if (index > 1) {
            item.isSubBegin = false;
            item.isSubComplete = false;
            item.isSubUpComing = true;
          }
        });

        stepsHandler(draft, draft.currentStep, state);
      });

    case RETIREMENT_CONFIRM_CHOICE_SUB_STEPS:
      return produce(state, (draft) => {
        draft.steps.map((step, i) => {
          if (draft?.chooseRetirementSteps?.isTakeMoneyInOneGo) {
            if (step.sequence === 3) {
              if (step.subSteps.length === 3) {
                if (action.data === "YES") {
                  step.subSteps = [...step.subSteps, contributionStep];
                } else {
                  step.subSteps = [
                    ...step.subSteps.filter((item) => item.sequence !== 34),
                  ];
                }
              }
              if (step.subSteps.length === 4) {
                if (action.data === "NO") {
                  step.subSteps = [
                    ...step.subSteps.filter((item) => item.sequence !== 34),
                  ];
                }
              }
            }
          }

          if (draft?.chooseRetirementSteps?.isTakeTaxFreeCashInvestRest) {
            if (step.sequence === 3) {
              if (step.subSteps.length === 6) {
                if (action.data === "YES") {
                  step.subSteps.splice(
                    step.subSteps.length - 1,
                    0,
                    contributionStep,
                  );
                } else {
                  step.subSteps = [
                    ...step.subSteps.filter((item) => item.sequence !== 34),
                  ];
                }
              }
              if (step.subSteps.length === 7) {
                if (action.data === "NO") {
                  step.subSteps.splice(step.subSteps.length - 2, 1);
                }
              }
            }
          }
          if (draft?.chooseRetirementSteps?.isTakeMoneyInOneChunk) {
            if (step.sequence === 3) {
              if (step.subSteps.length === 4) {
                if (action.data === "YES") {
                  step.subSteps.splice(
                    step.subSteps.length,
                    0,
                    contributionStep,
                  );
                } else {
                  step.subSteps = [
                    ...step.subSteps.filter((item) => item.sequence !== 34),
                  ];
                }
              }
              if (step.subSteps.length === 5) {
                if (action.data === "NO") {
                  step.subSteps.splice(step.subSteps.length - 1);
                }
              }
            }
          }
        });

        stepsHandler(draft, draft.currentStep, state);
      });

    case RETIREMENT_DIRECT_STEP_CHANGE:
      return produce(state, (draft) => {
        draft.applicationSteps = { ...state.applicationSteps, ...action.data };
      });

    case RETIREMENT_CHOOSE_START_AGAIN_POT_SELECTION:
      return produce(state, (draft) => {
        (draft.steps[2].subSteps[0].isSubBegin = true),
          (draft.steps[2].subSteps[0].isSubComplete = false),
          (draft.steps[2].subSteps[0].isSubUpComing = false),
          (draft.steps[2].subSteps[1].isSubBegin = false),
          (draft.steps[2].subSteps[1].isSubComplete = false),
          (draft.steps[2].subSteps[1].isSubUpComing = true),
          (draft.choose = {});
        draft.applicationSteps = {
          ...state.applicationSteps,
          ...{
            isRetirementDate: false,
            isPensionWise: false,
            isLumpSumAllowances: false,
            isPotSelection: true,
            isRetirementChoice: false,
            isConfirmChoice: false,
            isIllustration: false,
            isBankMandate: false,
            isBankMandateConfirm: false,
            isInvestRest: false,
            isTakeMoneyInOneChunk: false,
            isAnnuityHowMuchCash: false,
            isAnnuity: false,
            isRegularHowMuchCash: false,
            isTakingRegularIncome: false,
            isMixMatchHowMuchCash: false,
            isMixandMatch: false,
            isContribution: false,
            isIdv: false,
            isConfirmDeclaration: false,
            isDeclaration: false,
          },
        };
      });

    default:
      return state;
  }
};

export default retirementApplication;
